import { useSelector } from 'react-redux';

export function useSubscriptionCancellationStatus() {
	const isCancelled = useSelector((state) => {
		return (
			state.subscription.cancel.success ||
			(state.subscription.details.data?.nextStatus?.toLowerCase() === 'cancelled' &&
				!state.subscription.reactivate.success)
		);
	});

	return {
		isCancelled,
	};
}
